// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function attachVariants(component, variants) {
    for (const variantKey in variants) {
        component[variantKey] = variants[variantKey];
    }
    return component;
}
